<script>
import Base from "@/components/RequestDetailsForDefaultVue/FundCalc.vue";

export default {
  name: "CustomerServiceFilesFundCalc",
  extends: Base,
};
</script>
